

// import { messaging } from "../firebase";
// import { registerSW } from "../firebase";
// import { getToken, onMessage } from "firebase/messaging";
// import { BASE_URL } from "../keys";
// import { useEffect } from "react";

// const VAPID_KEY = "BE5ThkLRY1Nm9ntYsb-t-oG_BU5Uzi9FeIo3mfNxHyGZ-M5EN-vUEMKWmwfLfZgWRbnNcv8p2i4ge17iZqzwCOc";
// console.log("🔥 messaging instance:", messaging);
// const sendTokenToServer = async (fcmToken) => {
//   const authToken = localStorage.getItem("livtoken");
//   if (!authToken) {
//     console.warn("⚠️ No auth token available, skipping FCM token upload");
//     return;
//   }

//   const formData = new FormData();
//   formData.append("fcm_token", fcmToken);
//   formData.append("device_type", "web");

//   try {
//     const response = await fetch(`${BASE_URL}common/update-fcm-token/`, {
//       method: "POST",
//       headers: { Authorization: "Bearer " + authToken },
//       body: formData,
//     });

//     if (response.ok) {
//       console.log("✅ FCM token sent to server successfully");
//     } else {
//       const error = await response.json();
//       console.error("❌ Server error:", error);
//     }
//   } catch (error) {
//     console.error("❌ Network error sending FCM token:", error);
//   }
// };

// export const useNotification = () => {
//   // Setup foreground message listener
//   useEffect(() => {
//     console.log("vhbj");
    
//     const unsubscribe = onMessage(messaging, async (payload) => {
//       console.log("✅ Foreground message received:", payload);
//       // const { title, body } = payload.notification || {};
// const title = payload.notification?.title || payload.data?.title;
//       const body  = payload.notification?.body  || payload.data?.body;
// if (!title || Notification.permission !== "granted") return;

//       // if (title && Notification.permission === "granted") {
//       //   try {
//       //     const registration = await navigator.serviceWorker.ready;
//       //     registration.showNotification(title, {
//       //       body,
//       //       icon: `${window.location.origin}/logo192.png`,
//       //       badge: `${window.location.origin}/logo192.png`,
//       //       tag: "Hapsmiths",
//       //       data: payload.data || {},
//       //     });
//       //   } catch (err) {
//       //     console.error("Error showing notification:", err);
//       //   }
//       // }

//       // *********
//        try {
//         new Notification(title, {
//           body,
//           icon:  `${window.location.origin}/logo192.png`,
//           badge: `${window.location.origin}/logo192.png`,
//           tag:   "Hapsmiths",
//           data:  payload.data || {},
//         });
//         console.log("✅ Notification shown");
//       } catch (err) {
//         console.error("❌ Notification failed:", err);

//         // Fallback: use SW if native fails (e.g. mobile Chrome)
//         try {
//           const reg = await navigator.serviceWorker.ready;
//           await reg.showNotification(title, {
//             body,
//             icon:  `${window.location.origin}/logo192.png`,
//             badge: `${window.location.origin}/logo192.png`,
//             tag:   "Hapsmiths",
//             data:  payload.data || {},
//           });
//         } catch (swErr) {
//           console.error("❌ SW notification also failed:", swErr);
//         }}
//       // *****
//     });

//     return () => unsubscribe();
//   }, []);

//   const requestPermissionAndGetToken = async () => {
//     try {
//       if (Notification.permission === "denied") {
//         console.warn("❌ Notifications blocked by user.");
//         return;
//       }

//       // Request permission from user
//       const permission = await Notification.requestPermission();
//       if (permission !== "granted") {
//         console.warn("⚠️ Notification permission not granted");
//         return;
//       }

//       console.log("✅ Notification permission granted");

//       // Register Service Worker
//       const swReg = await registerSW();
//       if (!swReg) {
//         console.error("❌ Service Worker registration failed");
//         return;
//       }

//       // Get FCM token
//       const token = await getToken(messaging, {
//         vapidKey: VAPID_KEY,
//         serviceWorkerRegistration: swReg,
//       });

//       if (token) {
//         console.log("✅ FCM Token obtained:", token);
//         await sendTokenToServer(token);
//       } else {
//         console.warn("⚠️ Failed to obtain FCM token");
//       }
//     } catch (error) {
//       console.error("❌ Error in requestPermissionAndGetToken:", error);
//     }
//   };

//   return { requestPermissionAndGetToken };
// };


import { messaging } from "../firebase";
import { registerSW } from "../firebase";
import { getToken, onMessage } from "firebase/messaging";
import { BASE_URL } from "../keys";
import { useEffect } from "react";

const VAPID_KEY =
  "BE5ThkLRY1Nm9ntYsb-t-oG_BU5Uzi9FeIo3mfNxHyGZ-M5EN-vUEMKWmwfLfZgWRbnNcv8p2i4ge17iZqzwCOc";

const sendTokenToServer = async (fcmToken) => {
  const authToken = localStorage.getItem("livtoken");
  if (!authToken) {
    console.warn("⚠️ No auth token, skipping FCM token upload");
    return;
  }

  const formData = new FormData();
  formData.append("fcm_token", fcmToken);
  formData.append("device_type", "web");

  try {
    const response = await fetch(`${BASE_URL}common/update-fcm-token/`, {
      method: "POST",
      headers: { Authorization: "Bearer " + authToken },
      body: formData,
    });

    if (response.ok) {
      console.log("✅ FCM token sent to server");
    } else {
      const error = await response.json();
      console.error("❌ Server error:", error);
    }
  } catch (error) {
    console.error("❌ Network error sending FCM token:", error);
  }
};

export const useNotification = () => {
  useEffect(() => {
    if (!messaging) {
      console.error("❌ messaging is null");
      return;
    }

    console.log("✅ Setting up foreground onMessage listener");

    const unsubscribe = onMessage(messaging, async (payload) => {
      console.log("✅ Foreground message received:", payload);

      const title =
        payload.notification?.title || payload.data?.title;
      const body =
        payload.notification?.body || payload.data?.body;

      if (!title) {
        console.warn("⚠️ No title in payload, skipping notification");
        return;
      }

      if (Notification.permission !== "granted") {
        console.warn("⚠️ Notification permission not granted");
        return;
      }

      // ✅ Always use SW showNotification in foreground
      // new Notification() is unreliable when a SW is active
      try {
        const reg = await navigator.serviceWorker.ready;
        await reg.showNotification(title, {
          body,
          icon: `${window.location.origin}/logo192.png`,
          badge: `${window.location.origin}/logo192.png`,
          tag: `hapsmiths-${Date.now()}`, // ✅ unique = no silent replacement
          data: payload.data || {},
          // requireInteraction: true, // ✅ stays visible until clicked
        });
        console.log("✅ Foreground notification shown via SW");
      } catch (err) {
        console.error("❌ SW showNotification failed:", err);
      }
    });

    return () => {
      console.log("🔄 Cleaning up onMessage listener");
      unsubscribe();
    };
  }, []);

  const requestPermissionAndGetToken = async () => {
    try {
      if (Notification.permission === "denied") {
        console.warn("❌ Notifications blocked by user");
        return;
      }

      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.warn("⚠️ Permission not granted");
        return;
      }

      console.log("✅ Notification permission granted");

      const swReg = await registerSW();
      if (!swReg) {
        console.error("❌ SW registration failed");
        return;
      }

      const token = await getToken(messaging, {
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: swReg,
      });

      if (token) {
        console.log("✅ FCM Token:", token);
        await sendTokenToServer(token);
      } else {
        console.warn("⚠️ No FCM token obtained");
      }
    } catch (error) {
      console.error("❌ Error getting token:", error);
    }
  };

  return { requestPermissionAndGetToken };
};